import React, {Component} from 'react';
import './InnerHeaderBar.css';
import AddNewProjectButton from '../../components/Toolkit/AddNewProjectButton/AddNewProjectButton';
import AddNewProjectModal from '../../components/Toolkit/AddNewProjectModal/AddNewProjectModal';
class InnerHeaderBar extends Component {

  constructor(props) {
    super(props);
    this.defaultParams = {};
    this.state = {
        addProjectModal : false,
    };
  }

    openModal = () => {
        this.setState({addProjectModal : !this.state.addProjectModal});
    }

  render() {
    return (
        <div className="inner-header-bar">
            <div className="container-fluid">
                <div className='row'>
                    <div className="col-sm-12">
                        <h4 className='card-title'>{this.props.title}</h4>
                        { this.props.addNewProject &&
                            <AddNewProjectButton
                                openModal={this.openModal}
                                addProjectModal={this.state.addProjectModal}
                                createProject={this.props.createProject}
                                createdProjectFetching={this.props.createdProjectFetching}
                                createdProjectData={this.props.createdProjectData}
                                getProjectsList={this.props.getProjectsList}
                                addedNewProjectState={this.props.addedNewProjectState}
                            />
                        }
                        { this.state.addProjectModal &&
                            <AddNewProjectModal
                                openModal={this.openModal}
                                addProjectModal={this.state.addProjectModal}
                                createProject={this.props.createProject}
                                createdProjectFetching={this.props.createdProjectFetching}
                                createdProjectData={this.props.createdProjectData}
                                getProjectsList={this.props.getProjectsList}
                                addedNewProjectState={this.props.addedNewProjectState}
                            />
                        }


                    </div>
                </div>
            </div>
        </div>
    )
  }
}

export default (InnerHeaderBar);



// WEBPACK FOOTER //
// ./src/shared/InnerHeaderBar/InnerHeaderBar.jsx